import React from "react";
import ReactDOM from "react-dom";

import Popover from "../components/popover/popover";

function processPopovers(container = document) {
  container.querySelectorAll("[data-popover]").forEach(popover => {
    ReactDOM.render(<Popover {...popover.dataset} />, popover)
  });
}

export default processPopovers



// WEBPACK FOOTER //
// ./controllers/Popover.jsx